import createReactComponent from '../createReactComponent';
export default createReactComponent('corner-right-down', 'CornerRightDown', [["path",{"d":"M13.973 19V9a4 4 0 0 0-4-4H5m8.973 14-5.027-4.78M13.973 19 19 14.22","key":"svg-0"}]]);